module.exports = __webpack_public_path__ + "e0106718/img/archive-icon.0a6a9de3.svg";